module.exports = __webpack_public_path__ + "img/top-view-in-the-office.0ee68a78.jpg";